/* eslint-disable import/no-cycle */
import React from "react";
import { Divider } from "primereact/divider";
import { format } from "date-fns";
import {
  EditModalDate,
  EditModalHeaderText,
  EditModalSubHeaderText, HeaderHoursInfoContainer,
  HeaderHoursInfoWrapper,
  HeaderJobInfoContainer,
} from "./styledComponents";
import { UserColumnCell, UserColumnCellProps } from "../UserColumnCell/UserColumnCell";

export type ShiftAdjustHeaderProps = {
  headerText: string;
  subHeaderText: string;
  jobDate: Date;
  userInfo: UserColumnCellProps;
  shiftHours?: string;
};
export const ShiftAdjustHeader = ({
  headerText,
  subHeaderText,
  jobDate,
  userInfo,
  shiftHours,
}: ShiftAdjustHeaderProps) => (
  <>
    <EditModalHeaderText>{headerText}</EditModalHeaderText>
    <EditModalSubHeaderText>{subHeaderText}</EditModalSubHeaderText>
    <HeaderJobInfoContainer>
      <UserColumnCell
        firstName={userInfo.firstName}
        lastName={userInfo.lastName}
        jobInfo={userInfo.jobInfo}
        profilePic={userInfo.profilePic}
        externalId={userInfo.externalId}
        
      />
      <HeaderHoursInfoContainer>
        <EditModalDate>{format(jobDate, "EEE, MMM do")}</EditModalDate>
        <HeaderHoursInfoWrapper>{`${shiftHours ?? "0.00"}hrs`}</HeaderHoursInfoWrapper>
      </HeaderHoursInfoContainer>

    </HeaderJobInfoContainer>
    <Divider />
  </>
);
